import getApi from '../../api'
import { Task, TaskMutationPayload } from '../../model/Task'

export const updateTask = (id: number, task: TaskMutationPayload) =>
  getApi().put<Task>(`/tasks/${id}`, { ...task, isNotify: false })
